import { createResponse } from "../lib/functions";
import golApiCall from "./golApiCall";

function createPayload(bookingData) {
  const unconfirmedReservations =
    bookingData.UnconfirmedReservations?.UnconfirmedReservation ?? [];

  const confirmedReservation =
    bookingData?.BookedReservations?.BookedReservation[0];

  const actualizedServices = bookingData?.ActualizedServices?.ActualizedService;

  const references = unconfirmedReservations.map((unconfirmedReservation) =>
    unconfirmedReservation.FlightItinerary.FlightStream.reduce(
      (acc, fs) => [...acc, ...fs.FlightOption.map((o) => o.Reference)],
      []
    )
  );

  const services = actualizedServices
    ? {
        BookServices: {
          BookService: actualizedServices.map((actualizedService) => {
            return {
              PricedReference: {
                Price: actualizedService?.ActualPrice,
                Reference: actualizedService?.Reference,
              },
            };
          }),
        },
      }
    : {};

  const reservations = unconfirmedReservations.map(
    (unconfirmedReservation, index) => {
      return {
        Price: unconfirmedReservation.ActualFlightPricing.FlightPrice.FullPrice,
        Reference: references[index],
      };
    }
  );

  const linkedReservations = confirmedReservation
    ? {
        LinkedReservations: {
          Reservation: {
            ReservationId: confirmedReservation.ReservationId,
          },
        },
      }
    : {};

  return {
    GolApi: {
      RequestDetail: {
        BookReservationsConfirmRequest_1: {
          TicketingCombination: bookingData.TicketingCombination,
          ...services,
          BookReservationsConfirmations: {
            BookReservationConfirmation: reservations.map(
              (reservationParams) => ({
                ExternalReservationId: "",
                PricedReference: reservationParams,
              })
            ),
          },
          ...linkedReservations,
        },
      },
    },
  };
}

export default async function bookReservationsConfirmRequest1(bookingData) {
  const golRequest = createPayload(bookingData);
  const response = await golApiCall(golRequest);
  return createResponse(response);
}
